module.exports = __webpack_public_path__ + "static/media/bl.2a496da9.svg";